import { reviews } from "@/mocks/homeData";

const stats = [
  { num: "每日", label: "头号瓜深度解读" },
  { num: "30 分钟", label: "瓜榜更新频次" },
  { num: "90%+", label: "读者表示看懂了" },
];

export default function About() {
  return (
    <section id="about" className="relative overflow-hidden bg-background-100 py-16 md:py-24">
      <div className="absolute -left-24 top-16 -z-0 h-72 w-72 rounded-full bg-primary-200/40 blur-3xl" aria-hidden="true"></div>
      <div className="absolute -right-24 bottom-8 -z-0 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl" aria-hidden="true"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-600">关于今日大瓜 · ABOUT</p>
            <h2 className="mt-2 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
              我们想做的，不是制造瓜，<br className="hidden sm:block" />而是让你<span className="text-primary-600">看懂瓜</span>
            </h2>

            <div className="mt-7 space-y-5 text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
              <p>
                每天早晨，微博、短视频、资讯平台都会冒出形形色色的热搜。它们热闹、抓眼，却常常只剩一句标题，
                让人既不知道<strong className="font-semibold text-primary-700">这瓜到底讲的是谁</strong>，也不知道大家<b className="font-semibold">吵的点在哪里</b>。
              </p>
              <p>
                “今日大瓜”就是为此而生：我们把当天的碎片讨论<b className="font-semibold">归纳、去噪、排序</b>，
                用“讲的是谁 · 因何被议论 · 焦点在哪 · 最新进展”的结构重新讲一遍，让你点开一页就进入状态。
              </p>
              <p>
                我们的内容原则只有四条：<b className="font-semibold text-primary-700">客观转述、区分事实与观点、理性表达、以官方为准</b>。
                不炒作标题党，不编造当事人发言，热度退去后依然坚持真相优先。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {stats.map((s, i) => (
                <div key={i} className={`rounded-2xl border border-background-200/70 p-4 text-center ${i === 1 ? "bg-accent-100" : "bg-background-50"}`}>
                  <p className="font-heading text-xl font-black text-primary-700">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-heading text-lg font-bold text-foreground-900">读者口碑</h3>
              <span className="flex items-center gap-0.5 text-accent-500" aria-label="读者平均评分 4.8 分">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className={i === 5 ? "ri-star-half-line" : "ri-star-fill"} aria-hidden="true"></i>
                ))}
                <span className="ml-1 text-xs font-semibold text-foreground-700">4.8</span>
              </span>
            </div>
            <div className="mt-5 space-y-4">
              {reviews.map((r, i) => (
                <figure key={i} className="rounded-2xl border border-background-200/70 bg-background-50 p-5">
                  <div className="flex items-center justify-between">
                    <figcaption className="flex items-center gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-600 text-sm font-semibold text-background-50">
                        {r.name.slice(-2, -1) || "瓜"}
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-foreground-900">{r.name}</p>
                        <p className="text-xs text-foreground-500">{r.role}</p>
                      </div>
                    </figcaption>
                    <span className="flex text-accent-500">
                      {Array.from({ length: r.stars }).map((_, k) => (
                        <i key={k} className="ri-star-fill text-sm" aria-hidden="true"></i>
                      ))}
                    </span>
                  </div>
                  <blockquote className="mt-4 text-sm leading-7 text-foreground-700">“{r.text}”</blockquote>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}